export default __webpack_public_path__ + "static/media/image5.7ce51ae6.jpg";